<template>
  <v-snackbar v-model="alert1" :color="this.$store.state.app.alert.type" right top dark>
    <v-icon v-if="alert.type == 'success'" color="white" class="mr-3">done_outline</v-icon>
    <v-icon v-if="alert.type == 'info'" color="white" class="mr-3">priority_high</v-icon>
    <v-icon v-if="alert.type == 'warning'" color="white" class="mr-3">warning</v-icon>
    <v-icon v-if="alert.type == 'error'" color="white" class="mr-3">error</v-icon>
    <span class="font">{{alert.text}}</span>
    <v-icon dark size="30" color="white" @click="close">mdi-close-circle</v-icon>
  </v-snackbar>
</template>

<style>
.font {
  font-family: Poppins, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}
</style>


<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "core-alert",

  computed: {
    ...mapState("app", ["alert"]),
    alert1: {
      get() {
        return this.$store.state.app.alert.status;
      },
      set(value) {
        this.setAlert({
          status: value,
          text: "test",
          type: "error"
        });
      }
    }
  },

  methods: {
    ...mapMutations("app", ["setAlert"]),

    close() {
      this.$store.state.app.alert = false;
    }
  }
};
</script>